import { action } from "satcheljs";

export interface OnCopilotChatDrawerExpandedStateMessage {
    targetWindow: Window;
}

// Dispatched when the Copilot Chat Drawer is expanded
// Expanded means: Not at minimum width
export const onCopilotChatDrawerExpandedState: (targetWindow: Window) => OnCopilotChatDrawerExpandedStateMessage = action("onCopilotChatDrawerExpandedState", (targetWindow: Window): OnCopilotChatDrawerExpandedStateMessage => ({
    targetWindow,
}));
